import { EventsList } from '../../../EventsList/EventsList';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { useAuthClaims } from '../../../../hooks/useAuthClaims';
import { mapCalendarEventsToBpEventType } from '../../../../hooks/useCalendarEvents';
import { useQuery } from 'urql';
import { graphql } from 'client/gql';
import { DashboardEvent } from 'components/Home/getDashboardEvents';

type ClassbookEventsProps = {
  day: dayjs.Dayjs;
  onEventClick: (bpEvent: DashboardEvent) => void;
  className?: string;
  selectedUuid: string | null;
};

const ClassbookEventsQueryDocument = graphql(`
  query ClassbookEventsQueryDocument($calendarEventWhere: CalendarEventWhere!, $profile: ID!) {
    ...CalendarEventMapCalendarEventsToBpEventTypeFields
    ...EventsListFields
  }
`);

export const ClassbookEvents = ({ day, onEventClick, selectedUuid, className }: ClassbookEventsProps) => {
  const { pimAuthClaims } = useAuthClaims();
  const organizationUuid = pimAuthClaims.getOrganizationUuid();
  const profileUuid = pimAuthClaims.getProfile().uuid;

  const [{ data }] = useQuery({
    query: ClassbookEventsQueryDocument,
    variables: {
      profile: profileUuid,
      calendarEventWhere: {
        organization: {
          uuid: organizationUuid,
        },
        start_CONTAINS: day.format('YYYY-MM-DD'),
        categories_INCLUDES: 'lesson',
        attendeesConnection_SOME: {
          node: {
            uuid_IN: [pimAuthClaims.getProfile().uuid],
          },
        },
      },
    },
    requestPolicy: 'network-only',
  });

  const classbookEvents = useMemo(() => {
    // since we are not interested in "owner"-field as boolean indicator, we can pass empty string as currentProfileUuid and false as isAdmin
    return mapCalendarEventsToBpEventType(data, '', false) ?? [];
  }, [data]);

  return (
    <EventsList
      query={data}
      isOnWhite
      hideMonthHeadlines
      hideAddButton
      fullHeight
      showActive
      showClassNames
      onEventClick={(bpEvent) => {
        onEventClick(bpEvent);
      }}
      events={classbookEvents}
      scrollToUuid={selectedUuid}
      className={className}
    />
  );
};
